import * as RemixIcons from '@remixicon/react'

export type RemixIconKey = keyof typeof RemixIcons

export const RemixIconKeys = Object.keys(
  RemixIcons
) as ReadonlyArray<RemixIconKey>

// Partition Fill - All of the Remix components that have a Fill suffix like "Ri24HoursFill", "Ri4kFill", etc.

export type RemixFillIconKey = Extract<RemixIconKey, `${string}Fill`>

export const RemixFillIcons: Pick<typeof RemixIcons, RemixFillIconKey> =
  RemixIcons

export const RemixFillIconKeys = Object.keys(
  RemixFillIcons
) as ReadonlyArray<RemixFillIconKey>

// Partition Line - All of the Remix components that have a Line suffix like "Ri24HoursLine", "Ri4kLine", etc.

type RemixLineIconKey = Extract<RemixIconKey, `${string}Line`>

export const RemixLineIconKeys: Pick<typeof RemixIcons, RemixLineIconKey> =
  RemixIcons

// Partition Other - All of the rest of the Remix components that do not have a Fill or Line suffix like "RiAB", "RiAiGenerate", etc.

export type RemixOtherIconKey = Exclude<
  RemixIconKey,
  RemixFillIconKey | RemixLineIconKey
>

export const RemixOtherIconKeys = RemixIconKeys.filter(
  (k): k is RemixOtherIconKey => !k.endsWith('Fill') && !k.endsWith('Line')
) as ReadonlyArray<RemixOtherIconKey>
